import { useState, useEffect } from 'react';
import Hero from './components/Hero';
import About from './components/About';
import Products from './components/Products';
import Features from './components/Features';
import Contact from './components/Contact';

export default function HomePage() {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <div className="min-h-screen bg-[#FAFAFA]">
      {/* Navigation */}
      <nav
        className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
          scrolled ? 'bg-white shadow-lg' : 'bg-transparent'
        }`}
      >
        <div className="max-w-[1440px] mx-auto px-20 py-6 flex items-center justify-between">
          <div className="flex items-center gap-4">
            <img 
              src="https://public.readdy.ai/ai/img_res/4d967f61-a004-46d6-b6fd-e5ee89154f0e.png" 
              alt="FRENKI D.O.O. Logo" 
              className="h-10 w-10 object-contain"
            />
            <h1 className="text-2xl font-bold tracking-[2px] text-[#1A1A1A]">
              FRENKI D.O.O.
            </h1>
          </div>
          <div className="flex items-center gap-12">
            <button
              onClick={() => scrollToSection('home')}
              className="text-base font-medium text-[#1A1A1A] hover:text-[#4A9FFF] transition-colors duration-300 relative group cursor-pointer whitespace-nowrap"
            >
              Home
              <span className="absolute bottom-0 left-0 w-0 h-0.5 bg-[#4A9FFF] group-hover:w-full transition-all duration-300"></span>
            </button>
            <button
              onClick={() => scrollToSection('about')}
              className="text-base font-medium text-[#1A1A1A] hover:text-[#4A9FFF] transition-colors duration-300 relative group cursor-pointer whitespace-nowrap"
            >
              About
              <span className="absolute bottom-0 left-0 w-0 h-0.5 bg-[#4A9FFF] group-hover:w-full transition-all duration-300"></span>
            </button>
            <button
              onClick={() => scrollToSection('products')}
              className="text-base font-medium text-[#1A1A1A] hover:text-[#4A9FFF] transition-colors duration-300 relative group cursor-pointer whitespace-nowrap"
            >
              Products
              <span className="absolute bottom-0 left-0 w-0 h-0.5 bg-[#4A9FFF] group-hover:w-full transition-all duration-300"></span>
            </button>
            <button
              onClick={() => scrollToSection('features')}
              className="text-base font-medium text-[#1A1A1A] hover:text-[#4A9FFF] transition-colors duration-300 relative group cursor-pointer whitespace-nowrap"
            >
              Features
              <span className="absolute bottom-0 left-0 w-0 h-0.5 bg-[#4A9FFF] group-hover:w-full transition-all duration-300"></span>
            </button>
            <button
              onClick={() => scrollToSection('contact')}
              className="text-base font-medium text-[#1A1A1A] hover:text-[#4A9FFF] transition-colors duration-300 relative group cursor-pointer whitespace-nowrap"
            >
              Contact
              <span className="absolute bottom-0 left-0 w-0 h-0.5 bg-[#4A9FFF] group-hover:w-full transition-all duration-300"></span>
            </button>
          </div>
        </div>
      </nav>

      {/* Sections */}
      <div id="home">
        <Hero />
      </div>
      <div id="about">
        <About />
      </div>
      <div id="products">
        <Products />
      </div>
      <div id="features">
        <Features />
      </div>
      <div id="contact">
        <Contact />
      </div>
    </div>
  );
}